<template>
  <div class="mw-panel flow-tree-select" >
    <div class="mw-tree-search" v-if="search">
      <el-input
        :placeholder="$lang('请输入搜索内容')"
        v-model="searchText"
        clearable>
      </el-input>
    </div>
    <div :class="{'mw-tree-search__body':search,'mw-tree-no-search__body':!search}">
      <div class="mw-tree">

      </div>
    </div>
  </div>
</template>
<script>
  export default {

    name: 'MwCompleteTree',
    props: {
      search:{
        type: Boolean,
        default: false
      },
      //是否自动加载
      autoLoad:{
        type: Boolean,
        default: true
      },
      //默认的根节点条件
      defaultParentId:{
        type: String
      },
      //默认参数
      defaultParams:{
        type: Object,
        default: function () {
          return {}
        }
      },
      //加载数据地址
      url: {
        type: String,
        required: true
      },
      rootData:Array,
      //是否打开第一个节点
      expandedFirst: {
        type: Boolean,
        default: false
      },
      //和展开第一个节点一起用，多个节点不展开
      mulNodeNotExpand:{
        type: Boolean,
        default: false
      },
      autoSelectSingle:Boolean,
      autoSelectData:{
        type: Boolean,
        default: false
      },
      //是否异步加载
      async: {
        type: Boolean,
        default: false
      },
      //是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      singleLeaf: {
        type: Boolean,
        default: false
      },
      //多选是否只选最子节点
      multipleLeaf: {
        type: Boolean,
        default: false
      },
      contextMenuItem: {
        type: Array,
        default: function () {
          return [];
        }
      },
      //多选时选中的ID
      checkNodes: {
        type: Array,
        default: function () {
          return [];
        }
      },
      //单选选中ID
      selectNode: {
        type: String,
        default: ''
      },
      type:{
        type: String
      },
      activityId:{
        type: String
      },
      businessId:{
        type: String
      },
      batchId:{
          type:String
      },
      taskId:{
        type:String
      },
      // 静态数据
      treeData: {
        type: [Array,Object]
      },
      flowCount:Number
    },
    data() {
      return {
        searchFlag:false,
        searchText:'',
        selectData: {},
        selectParents: [],
        dblClick:false,
        select:false,
        deselect:false,
        check:false,
        expanded_first:false,
        open_last_id:'',
        refreshIds:[],
        initData:[],
        firstCount:0,
        firstLoaded:false,
        authSelectedData:false,
        leafTypes:["file","zg","wc","dg"],
        openedIds:[],
        removeIds:[],
        candidateShowsCurrentStatus : (window.$Env && $Env.candidateShowsCurrentStatus)
      }
    },
    watch: {
      checkNodes(newIds) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.uncheck_all();
        newIds.forEach(id => {
          let obj = inst.get_node(id);
          inst.check_node(obj);
        })
      },
      selectNode(newId) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
        if (newId) {
          let obj = inst.get_node(newId);
          inst.select_node(obj);
        }
      },
      searchText(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true)
        if(val==''){
          setTimeout(function() {
            tree.clear_search()
          }, 250);
        }else{
          if (this.searchFlag) {
            clearTimeout(this.searchFlag)
          }
          this.searchFlag = setTimeout(function() {
            tree.search(val,true,true)
          }, 250);
        }
      },
      url(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      }
    },
    mounted() {
      let me=this;
      if(this.autoLoad){
        if(this.type=="startSubProcess"){
          if(this.businessId && this.batchId){
            //me.mwApi.process.getTaskEntityData(me.taskId).then((data) => {
              this.mwApi.process.listPlannedSubByBatchIdAndActivityId(this.batchId, this.activityId).then(v => {
                if (v.result) {
                  v.result.forEach(v1 => {
                    //if(v1.sendExecutionId==data.result.processInstanceId)
                      me.removeIds.push(/*v1.departmentId+"_"+*/v1.id);
                  })
                }
                this.renderTree();
              })
            //});
          }
          return
        }
        this.renderTree();
      }
    },
    destroyed() {
      let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
      if(tree){
        tree.destroy();
      }
    },
    methods: {
      checkAll() {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.select_all();
      },
      unCheckAll() {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
      },
      openAll() {
        $(this.$el.querySelector('.mw-tree')).jstree('open_all');
      },
      closeAll() {
        $(this.$el.querySelector('.mw-tree')).jstree('close_all');
      },
      refresh() {
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      },
      refreshData(data){
        $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      },
      showNode(id){
        let me=this;
        let obj= $(me.$el.querySelector('.mw-tree')).jstree(true).get_node(id);
        $(me.$el.querySelector('.mw-tree')).jstree(true).show_node(obj);
      },
      getSelectNodes(noHide){
        let me = this;
        let tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
        let selected = tree.get_selected();
        let data=[];
        if (selected.length > 0) {
          selected.forEach(id => {
            var obj=tree.get_node(id);
            if(me.leafTypes.indexOf(obj.type) != -1 && !obj.state.hidden){
              if(!noHide)tree.hide_node(obj);
              var d=Object.assign({parentId:obj.parent},obj.original);
              data.push(d);
            }
          });
        }
        return data;
      },
      getSelected() {
        let tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
        let selected = tree.get_selected();
        let data=[];
        if (this.multiple) {
          if (selected.length > 0) {
            data = [];
            selected.forEach(id => {
              data.push(tree.get_node(id).original);
            });
          }
        } else {
          if (selected.length > 0) {
            data = tree.get_node(selected[0]).original;
          }
        }
        return data;
      },
      renderTree() {
        let me = this, jsTreeEl = $(me.$el.querySelector('.mw-tree'));
        let plugin = ["types"];
        let items = {};
        if (me.multiple) {
          plugin.push("checkbox");
          plugin.push("wholerow");
        } else {
          plugin.push("wholerow");
        }
        if(me.search){
          plugin.push("search");
        }
        if (me.contextMenuItem.length > 0) {
          plugin.push("contextmenu");
          me.contextMenuItem.forEach(item => {
            items[item.name] = {
              "name": item.name ? item.name : '',
              "label": item.label,
              "icon": item.icon ? item.icon : '',
              "action": function (a) {
                item.func(me.selectData, me.selectParents);
              }
            }
          });
        }
        let data = {};
        if (me.treeData) {
          data = me.treeData
        } else {

          let dataConfig = {
            cache:false,
            async: false,
            "url": function (node) {
              let arr = [];
              for(let p in me.defaultParams) {
                arr.push(p + "=" + me.defaultParams[p]);
              }
              if (node.id === '#') {
                return me.url+ '?'+arr.join("&") ;
              } else {
                return me.url + '/' + node.id+ '?'+arr.join("&");
              }
            },
            'data': function (node) {
              return {'id': node.id};
            },
            dataFilter: function (data,parentId) {
              let isString=typeof(data)==='string';
              if(isString)data = JSON.parse(data);
              if(!me.firstLoaded){
                this.getNoChildren(data);
              }
              if (data) {
                if(window.$currentBrowserLanguage==='en'){
                  PF.walkTree(data,d=>{
                    d._name=d.name;
                    if (d.name === '<任务结束>' || d.name === '<流程结束>') {
                      d.name = $lang(d.name);
                    }else{
                      d.name=d.Englishname || d.name;
                    }
                  });
                }
                this.changeTreeData(data,{id:parentId});
              } else {
                data = [];
              }
              if(me.firstLoaded){
                let resData=[];
                //this.data.split('=')[1] this.data不是字符串
                this._initData(me.initData, data,parentId,resData);
                if(resData.length>0){
                  return resData[0].children//JSON.stringify(resData[0].children);
                }else{
                  return data//JSON.stringify(data);
                }
              }else{
                me.initData=data;
              }
              return data//isString?JSON.stringify(data):data;
            },
            _initData(data,nData,curId,resData){
              for(let i=0;i<data.length;i++) {
                let v = data[i];
                if (v.children instanceof Array) {
                  if (v.id == curId ) {
                    for (let j = nData.length - 1; j >= 0; j--) {
                      v.children.unshift(nData[j]);
                    }
                    resData.push(v);
                  }else{
                    this._initData(v.children, nData, curId,resData)
                  }
                }
              }
            },
            getNoChildren(data){
              data.forEach(d => {
                if(d.children){
                  this.getNoChildren(d.children);
                }else{
                  me.refreshIds.push(d.id);
                }
              })
            },
            changeTreeData(data,parent) {
              if(me.type=="startSubProcess") {
                let m=this;
                me.mwLodash.remove(data, function (d) {
                  //if (d.type && d.type == 'U') {
                    let dataId = '';
                    if (parent) {
                      dataId = /*parent.id + "_" +*/ d.id
                    } else {
                      dataId = /*m.data.split('=')[1] + "_" +*/ d.id;
                    }
                    let flag = false;
                    me.removeIds.forEach(id => {
                      if (id == dataId) {
                        flag = true;
                      }
                    });
                    return flag;
                  //} else {
                   // return false;
                 // }
                });
              }
              data.forEach(d => {
                if (!d.text) {
                  if (d.name)
                    d.text = d.name;
                }
                if(d.type && d.type=='U'){
                  if(parent)
                    d.id=parent.id+"_"+d.id;
                  else{
                      if(d.parentId){
                        this.parentNodeId = d.parentId;
                        d.id = d.parentId+"_"+d.id
                      }
                      //this.data.split报错，不是字符串
                      //d.id=this.data.id.split('=')[1]+"_"+d.id;
                  }
                }
                if(d.children){
                  this.changeTreeData(d.children,d);
                }else{
                  if(!d.hasReal && d.type=="U" && me.candidateShowsCurrentStatus){
                    d.type = d.fldgwzt=="外出" ? "wc": d.fldgwzt=="调岗" ? "dg":"zg";
                    if(d.defaultAgent){
                      d.text = d.text + "["+d.defaultAgent+"代办]";
                    }
                  }else if(d.hasReal==undefined){
                    d.children=false;
                    d.type='file';
                  }else{
                    d.children=d.hasReal;
                    if(!d.hasReal){
                      d.type='file';
                    }else{
                      d.type='default';
                    }
                  }
                }
              })
            },
            "success": function (data) {
              return data;
            }
          }
          data=function(node,callback){
            let me = this;
            if (node.id === "#" && me.rootData) {
              callback(processData(me.rootData));
            }else{
              let url=dataConfig.url(node);
              $.ajax({
                url:url,
                data:{id:node.id},
                method:"POST",
                success(d){
                  let data=processData(d,node.id);
                  callback.call(me,data);
                }
              })
            }
            function processData(data,parentId){
              return dataConfig.dataFilter(data,parentId);
            }
          }
        }

        jsTreeEl.data('jstree', false).empty();
        jsTreeEl.bind("load_node.jstree", function (e, data) {
          let inst = data.instance;
          let set = inst.settings;
          if (set.async && me.expandedFirst) {
            if (data.node && data.node.children &&  (["<流程结束>",$lang("<流程结束>")].indexOf(data.node.children) != -1 || ["<任务结束>",$lang("<任务结束>")].indexOf(data.node.children[0]) != -1) && (me.flowCount!=undefined && me.flowCount==1)){
              if (me.autoSelectSingle) {
                var h=jsTreeEl.jstree(true).get_node(data.node.children);
                jsTreeEl.jstree(true).hide_node(h);
                me.$emit("dblClick",h.original,h.parent);
              }
              return;
            }
            if (data.node && data.node.children && !set.expanded_first) {
              function open_first_node(node) {
                if (node && (node.id=="#" || node.original && ( node.original.hasChild > 0 || node.original.hasReal))) {
                  me.firstCount++;
                   let ns=[];
                  if(node.children && node.children.length > 1 && me.mulNodeNotExpand && !me.autoSelectData){
                    return;
                  }
                   if(me.type!='circular'){
                      if(node.children){
                        for (let i = 0; i < node.children.length; i++){
                          let id=node.children[i];
                          let v=inst.get_node(id);
                          if(me.autoSelectData){
                            ns.push(v)
                          }else{
                            if (v.children &&  v.children.length>0) {
                              ns.push(v);
                            }
                          }
                        }
                      }
                   }else{
                     var n = inst.get_node(node.children[0]);
                     if(n)
                      ns.push(n);
                   }
                   if(ns.length > 0){
                     for(var i=0;i<ns.length;i++){
                        var n = ns[i];
                       if(n) {
                         me.refreshIds.push(n.original.id);
                         me.openedIds.push(n.original.id);
                         if(i==ns.length-1)
                          me.open_last_id = n.original.id;
                       }
                       inst.open_node(n);
                       open_first_node(n);
                     }
                   }else{
                     me.expanded_first=true;
                     set.expanded_first = true;
                   }
                } else {
                  me.expanded_first=true;
                  set.expanded_first = true;
                }
              }
              open_first_node(data.node);
            }
          }
        }).on("before_open.jstree", function (el,data) {

        }).on("after_open.jstree", function (el,data) {
          let inst = data.instance;
          let set = inst.settings;
          if(me.firstLoaded &&  me.type!='circular'){
            let n = inst.get_node(data.node.id);
            if (n && n.original.hasReal != undefined && n.original.hasReal && n.children && n.children.length>0 ) {
              let id = n.original.id;
              if (me.refreshIds.indexOf(id) == -1) {
                me.refreshIds.push(id);
                jsTreeEl.jstree(true).refresh_node(n);
              }
            }
          }
          if(me.type=='circular' && set.expanded_first && me.firstLoaded){
            let node = inst.get_node(data.node.id);
            var children=node.children;
            if(children){
              children.map(v=>{
                let n = jsTreeEl.jstree(true).get_node(v);
                if(n.original && me.openedIds.indexOf(n.id) == -1 && me.leafTypes.indexOf(n.original.type) == -1){
                      jsTreeEl.jstree(true).open_node(n);
                }
                me.openedIds.push(n.original.id);
              })
            }
          }
          if(me.autoSelectData)me.firstCount--;
          if(me.expanded_first){
            var flag=false;
            var obj=jsTreeEl.jstree(true).get_node(me.open_last_id);
            if(!me.autoSelectData)me.firstCount--;
            if(me.firstCount<2){
              me.firstLoaded=true;
            }
            if(!me.open_last_id || me.flowCount==undefined || me.flowCount!=1){
              return;
            }
            function search(id){
              var o=jsTreeEl.jstree(true).get_node(id);
              if(o.children.length>1){
                flag=true;
              }else{
                if(o.parent=='#'){
                  var p=jsTreeEl.jstree(true).get_node("#");
                  if(p.children.length>1){
                    flag=true;
                  }
                }else{
                  search(o.parent)
                }
              }
            }
            search(me.open_last_id);
            if(me.autoSelectSingle && !flag){
              var h=jsTreeEl.jstree(true).get_node(obj.children[0])
              jsTreeEl.jstree(true).hide_node(h);
              me.$emit("dblClick",h.original,h.parent);
            }
            me.expanded_first=false;
          }
          if(!me.authSelectedData && me.firstCount<2){
            if(me.autoSelectData){
              let doSelFn = function(vs){
                _.each(vs,function(n){
                  var node=jsTreeEl.jstree(true).get_node(n);
                  if(!node.children ||  node.children.length===0){
                    jsTreeEl.jstree(true).hide_node(node);
                    me.$emit("dblClick",node.original,node.parent);
                  }else{
                    doSelFn(node.children);
                  }
                })
              }
              if(data.node.parents && data.node.parents.length > 0){
                var n = [data.node.parents[data.node.parents.length >= 2 ? data.node.parents.length-2 : 0]];
                doSelFn(n);
                me.authSelectedData = true;
              }
            }
          }
        }).on("changed.jstree", function (e, data) {

        }).bind("loaded.jstree", function (e, data) {
          jsTreeEl.delegate(".jstree-checkbox",'mousedown', function (e) {
            // e.stopPropagation();
            var id = $(this).parent()[0].id;
            let inst =jsTreeEl.jstree(true)
            var obj = inst.get_node(id);
            if(!me.dblClick) {
              me.check = true;
              if (obj.state.selected != undefined) {
                if (obj.state.selected) {
                  // inst.deselect_node(obj);
                } else {
                  // inst.select_node(obj);
                  function open_first_node(node) {
                    inst.open_node(node);
                    if (!node.original || node.original && me.leafTypes.indexOf(node.original.type) == -1) {
                      me.openedIds.push(node.original.id);
                      if(me.type!='circular'){
                        var children=node.children;
                        children.map(v=>{
                          let n = inst.get_node(v);
                          inst.open_node(n);
                          open_first_node(n);
                        })
                      }
                    }
                  }
                  open_first_node(obj);

                }
              }
              me.check=false;
            }
          })
        }).bind("click.jstree", function(e, data) {

        }).bind("dblclick.jstree", function(e, data) {
          var id=e.target.id.substr(0,e.target.id.lastIndexOf('_'));
          var obj =  jsTreeEl.jstree(true).get_node(id);
          me.dblClick=true;

          if (obj) {
            if(me.leafTypes.indexOf(obj.original.type) != -1 ){
              function callback(){
                jsTreeEl.jstree(true).hide_node(obj);
              }
              me.$emit("dblClick",obj.original,obj.parent,callback);
              //jsTreeEl.jstree(true).delete_node (obj);
            }else{
              if (obj.state.selected) {
                jsTreeEl.jstree(true).deselect_node(obj);
              } else {
                jsTreeEl.jstree(true).select_node(obj);
                if(me.openedIds.indexOf(obj.original.id) == -1){
                  function open_first_node(node) {
                    jsTreeEl.jstree(true).open_node(node);
                    if (!node.original || node.original && me.leafTypes.indexOf(node.original.type) == -1) {
                      me.openedIds.push(node.original.id);
                      var children=node.children;
                      children.map(v=>{
                        let n = jsTreeEl.jstree(true).get_node(v);
                        jsTreeEl.jstree(true).open_node(n);
                        open_first_node(n);
                      })
                    }
                  }
                  open_first_node(obj);
                }else{
                  if (obj.state.opened && me.multiple) {
                    jsTreeEl.jstree(true).close_node(obj);
                  }
                }
              }
            }
          }
          me.dblClick=false;

        }).bind("check_node.jstree", function(e, data) {
        }).bind("select_node.jstree", function(e, data) {
          if(!me.check ){
            if(me.multiple){
              if(!me.dblClick && !me.deselect && !me.select ){
                var inst = data.instance;
                var obj = inst.get_node(data.node.original.id);
                me.select=true;
                inst.deselect_node(obj);
                me.select=false;
              }
              if(!me.dblClick && !me.deselect && me.select){
                var inst = data.instance;
                var obj = inst.get_node(data.node.original.id);
                inst.select_node(obj);
              }
            }
          }
        }).bind("deselect_node.jstree", function(e, data) {

          if(!me.check ) {
            if(me.multiple){
              if (!me.dblClick && !me.select && !me.deselect) {
                var inst = data.instance;
                var obj = inst.get_node(data.node.original.id);
                me.deselect = true;
                inst.select_node(obj);
                me.deselect = false;
              }

              if (!me.dblClick && !me.select && me.deselect) {
                var inst = data.instance;
                var obj = inst.get_node(data.node.original.id);
                inst.deselect_node(obj);
              }
            }
          }
        }).jstree({
          'async': me.async, //url 是一次性加载，还是异步
          'expanded_first': false,//是否已经展开树节点
          'core': {
            "themes": {
              "responsive": false
            },
            "multiple": me.multiple,  //不允许多选
            "check_callback": function (operation, node, node_parent, node_position, more) {
              return true;
            },
            'data': data

          },
          'checkbox': {
            "keep_selected_style": false,
            "three_state": true,
            "visible": true,
            "tie_selection":true
          },
          "plugins": plugin,
          "contextmenu": {
            "items": items
          },
          "types": {
            "#": {
              "icon": "fa fa-folder"
            },
            "file": {
              "icon": "fa fa-leaf"
            },
            "zg":{
              "icon": "icon-green fa fa-user"
            },
            "wc":{
              "icon": "icon-yellow fa fa-user",
              "color":"yellow"
            },
            "dg":{
              "icon": "icon-grey fa fa-user"
            },
            "default": {
              "icon": "fa fa-folder"
            }
          },
        })
      },
    }
  }
</script>
<style >
 .flow-tree-select .mw-tree .icon-yellow{
   color: yellow;
 }
 .flow-tree-select .mw-tree .icon-green{
   color: green;
 }
 .flow-tree-select .mw-tree .icon-grey{
   color: grey;
 }
</style>



// WEBPACK FOOTER //
// src/common/components/public-dialog/tree/index.vue